module.exports = __webpack_public_path__ + "media/images/icons/icon_triangle_arrow_right_primary-076c41ef90fafc7b9fb9016ab0fc62d3.svg";